module.exports = __webpack_public_path__ + "media/packs/images/label-41d8d3fc6793b21e7af2ce16676bce37.svg";